import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import OrderManagementTable from "../../components/OrderManagement/OrderManagementTable";
import OrderManagementV2 from "../../components/OrderManagement/OrderManagementV2";





const OrderManagement = () => {
    return (
        <>
        
            <MasterLayout>

                <Breadcrumb title="Shipment Orders" />
                {/* <OrderManagementTable/> */}
                <OrderManagementV2/>


          
           



            </MasterLayout>
        </>
    );
};

export default OrderManagement;
